// extracted by mini-css-extract-plugin
module.exports = {"tdBody":"plan_tdBody__1lfpk","table1":"plan_table1__2yVjt","tbodyTable2":"plan_tbodyTable2__EA14j"};